export default __webpack_public_path__ + "static/media/multi-pitch.9ece8a3c.png";